import { render, staticRenderFns } from "./PersonOverview.vue?vue&type=template&id=6baf65fa&scoped=true&"
import script from "./PersonOverview.vue?vue&type=script&lang=js&"
export * from "./PersonOverview.vue?vue&type=script&lang=js&"
import style0 from "./PersonOverview.vue?vue&type=style&index=0&id=6baf65fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baf65fa",
  null
  
)

export default component.exports